import gql from "graphql-tag";

/**
 * @param {string} team_id
 */
export const SUBSCRIBE_USER_LIST_BY_TEAM_ID = gql`
  subscription fetchUserListByTeamId($team_id: uuid!) {
    user(where: { team_id: { _eq: $team_id } }) {
      email
      id
      name
    }
  }
`;
